import Contact from "../home/components/contact/Contact";

const ContactUsPage = () => {
  return (
    <div className="text-black">
      <Contact />
    </div>
  );
};

export default ContactUsPage;


